import React, { useState } from "react";
import { useAuth } from "../AuthProvider";

export default function SnapshotSignalsButton({ className = "" }) {
  const { token } = useAuth() || {};
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (loading) return;

    const ok = window.confirm(
      "Run Snapshot Signal (EOD) sekarang?\n\nPastikan data OHLC hari ini sudah di-upload."
    );
    if (!ok) return;

    setLoading(true);

    try {
      const headers = { "Content-Type": "application/json" };
      if (token) headers["Authorization"] = `Bearer ${token}`;

      const res = await fetch("/api/stocks/snapshot-signals", {
        method: "POST",
        headers,
        body: JSON.stringify({}), // aman walau backend tidak butuh body
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.detail || "Snapshot signals gagal");
      }

      // fleksibel: backend bisa return total/rows_saved/skipped, dll
      const tradeDate = data.trade_date || data.signal_date || "-";
      const total = data.total ?? data.rows_saved ?? "-";
      const skipped = data.skipped ?? 0;
      const status = data.status || "success";

      if (status === "skipped") {
        alert(
          `Snapshot sudah pernah dibuat.\nTrade Date: ${tradeDate}\nReason: ${data.reason || "-"}`
        );
      } else {
        alert(
          `Snapshot Signal berhasil.\nTrade Date: ${tradeDate}\nRows tersimpan: ${total}\nSkipped: ${skipped}`
        );
      }
    } catch (err) {
      console.error(err);
      alert(`Run Snapshot gagal: ${err.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      className={`w-full py-2 px-3 rounded-lg text-left text-sm
        ${loading ? "bg-slate-700 cursor-wait" : "bg-amber-700 hover:bg-amber-600"}
        ${className}`}
    >
      {loading ? "Running Snapshot..." : "Run Snapshot Signal (EOD)"}
    </button>
  );
}
